// removed by extract-text-webpack-plugin
module.exports = {"promoWrap":"LearnMore__promoWrap--2UAPm"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/LearnMore/LearnMore.css
// module id = fZMt
// module chunks = 43